import { Injectable } from '@angular/core';

// To be used in dialogs where the component does not itself have the isBusy flag.
@Injectable({ providedIn: 'root' })
export class BusyService {
  public busyPromise: Promise<any> | undefined;

  public isBusy() {
    return this.busyPromise != null;
  }

  public async wrapBusy<T>(op: Promise<T> | (() => Promise<T>)) {
    if (this.busyPromise) {
      return await (typeof op === 'function' ? op() : op);
    }

    try {
      this.busyPromise = typeof op === 'function' ? op() : op;
      return await this.busyPromise;
    } finally {
      this.busyPromise = undefined;
    }
  }
}
